import { render } from "./virtualNumber.vue?vue&type=template&id=2b45f332&scoped=true"
import script from "./virtualNumber.vue?vue&type=script&lang=js"
export * from "./virtualNumber.vue?vue&type=script&lang=js"

import "./virtualNumber.vue?vue&type=style&index=0&id=2b45f332&lang=scss&scoped=true"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b45f332"]])

export default __exports__